<template>
  <v-layout>
    <carousel ref="carousel" :carousel-items="dishes">
      <dish-chip
        v-for="(dish, i) in dishes.reverse()"
        :key="i"
        :dish="dish"
        :editable="editable"
        :dishes-count="dishes.length"
        :state="state"
        @removeSelection="d => removeSelection(d)"
      />
    </carousel>
  </v-layout>
</template>

<script>
import DishChip from './DishChip.vue';
import Carousel from '../../../common/carousel/Carousel.vue';

export default {
  name: 'OrdersListBig',
  components: {
    'dish-chip': DishChip,
    carousel: Carousel,
  },
  props: {
    dishes: {
      type: Array,
      default: () => [],
    },
    state: {
      type: String,
      required: true,
    },
    editable: Boolean,
  },
  watch: {
    state(newValue) {
      if (newValue === 'done') {
        this.$refs.carousel.recalculateOverflow();
      }
    },
    dishes() {
      this.$refs.carousel.recalculateOverflow();
    },
  },
  methods: {
    removeSelection(dish) {
      if (this.$refs.carousel.firstVisibleChildIndex > 0) {
        this.$refs.carousel.moveRight();
      }
      this.$emit('removeSelection', dish);
    },
  },
};

</script>

<style>
.orders-list-button {
  transition: none !important;
  min-width: 60px;
}
</style>
